/**
 * The two halves of the API's base64 file shape — picking a file to upload, and opening one that
 * was downloaded. Shared by help desk, the social wall, travel and company policies.
 *
 * Its own module, not part of `features/company-policies/policyShared.tsx` where it started: that
 * file renders Markdown, and every page that only wanted these helpers was pulling the Markdown
 * renderer in with them — far enough that it ended up in the app's first load.
 */

/** Opens a base64 file (the download routes' shape) in a new tab. */
export function openBase64File(file: { mimeType: string; contentBase64: string }): void {
  const binary = atob(file.contentBase64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) bytes[i] = binary.charCodeAt(i);
  const url = URL.createObjectURL(new Blob([bytes], { type: file.mimeType }));
  window.open(url, '_blank', 'noopener');
  // Revoked later, not now: the new tab has to finish reading it first.
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}

/** The base64 payload of a picked file, without the `data:` prefix. */
export function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error('Could not read the file'));
    reader.onload = () => {
      const result = typeof reader.result === 'string' ? reader.result : '';
      const comma = result.indexOf(',');
      resolve(comma >= 0 ? result.slice(comma + 1) : result);
    };
    reader.readAsDataURL(file);
  });
}
